/**
 * Состав пака «left-soft» (WEB-3718) — смысл групп и источник каждого числа:
 * `../stylePackComposition.ts`. Файл на пак, общий список `./index.ts`
 * собирается по каталогу (решение владельца 23.10 ~04:35).
 */
import type { StylePackComposition } from '../stylePack.types';

export const composition: StylePackComposition = {
  // 9 воронок: группы.json, группы 12 (PACK в matrix.py)
  palettes: [
    // 2 из 9 воронок: palette → ближайшая тема по цветам
    { themeId: 'rose-blush', weight: 0.22 },
  ],
  fonts: [
    // 5 из 9 воронок: fontId
    { fontId: 'inter', weight: 0.56 },
    // 2 из 9 воронок: fontId
    { fontId: 'poppins', weight: 0.22 },
  ],
  screenKinds: [
    // средняя доля экранов по 9 воронкам (признаки.json kinds) 0.427; сюда свёрнуты Q10, Q6, Q9 (замена из arsenal.mjs)
    { kind: 'Q1', share: 0.47 },
    // средняя доля экранов по 9 воронкам (признаки.json kinds) 0.146; сюда свёрнуты I2 (замена из arsenal.mjs)
    { kind: 'I1', share: 0.16 },
    // средняя доля экранов по 9 воронкам (признаки.json kinds) 0.105
    { kind: 'N1', share: 0.12 },
    // средняя доля экранов по 9 воронкам (признаки.json kinds) 0.067
    { kind: 'N2', share: 0.07 },
    // средняя доля экранов по 9 воронкам (признаки.json kinds) 0.050
    { kind: 'Q8', share: 0.06 },
    // средняя доля экранов по 9 воронкам (признаки.json kinds) 0.039
    { kind: 'N5', share: 0.04 },
    // средняя доля экранов по 9 воронкам (признаки.json kinds) 0.038
    { kind: 'N6', share: 0.04 },
    // средняя доля экранов по 9 воронкам (признаки.json kinds) 0.032
    { kind: 'N3', share: 0.03 },
  ],
  blocks: [
    // в 9 из 9 воронок (признаки.json blocks), подъём 1.46; настройки — большинство в собранных воронках (out/_packs2/all/*/converted): autoAdvance 59 из 115, optionIndicator 97 из 115
    {
      type: 'single_choice',
      weight: 1.0,
      settings: { autoAdvance: true, optionIndicator: 'none' },
    },
    // в 4 из 9 воронок (признаки.json blocks), подъём 0.99
    { type: 'multiple_choice', weight: 0.44, settings: {} },
    // в 6 из 9 воронок (признаки.json blocks), подъём 1.66
    { type: 'email', weight: 0.67, settings: {} },
    // в 2 из 9 воронок (признаки.json blocks), подъём 3.68
    { type: 'video_embed', weight: 0.22, settings: {} },
    // в 2 из 9 воронок (признаки.json blocks), подъём 3.35
    { type: 'number_input', weight: 0.22, settings: {} },
    // в 2 из 9 воронок (признаки.json blocks), подъём 2.91
    { type: 'micro_feedback', weight: 0.22, settings: {} },
    // в 3 из 9 воронок (признаки.json blocks), подъём 1.15
    { type: 'text_field', weight: 0.33, settings: {} },
  ],
  niches: [
    // 3 из 9 воронок (признаки.json theme)
    { niche: 'fitness', weight: 0.33 },
    // 2 из 9 воронок (признаки.json theme)
    { niche: 'astrology', weight: 0.22 },
  ],
};
